import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface PathLabelProps {
  path: string;
  meta?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function PathLabel({ path, meta, children, className }: PathLabelProps) {
  return (
    <div
      className={cn(
        'font-tech flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-1 break-words text-[11px] uppercase tracking-[0.18em] text-text-3',
        className,
      )}
    >
      <span className="text-text-2">{path}</span>
      {meta && (
        <>
          <span className="text-text-4">·</span>
          <span>{meta}</span>
        </>
      )}
      {children}
    </div>
  );
}
